import React, { Fragment, useEffect, useRef,useCallback, useReducer } from 'react'
import { isEmpty } from 'lodash';
import { withRouter } from 'react-router'
import "../../components/PlayerAndCarousel/Workout/Workout.css";
import Grid from "@material-ui/core/Grid";
import { Typography, Button } from "@material-ui/core";
import { getNextOccurenceDate, getTimetoStart, isSLClassStarted } from '../../utils/LivestreamTime';
import { Translate } from '../../utils/Translate';
import ClubCardNew from '../../containers/LiveConnect/ClubCardNew';
// import videojs from "video.js";

import Spinner from "../../components/spinner/spinner";
import Modal from '../../components/PlayerAndCarousel/VideoWrapper/QuitAndLogVideoUi'
import PureVideoWrapper from './LSPlayerWrapper';
import ClassCompleted from './ClassCompleted';
import logger from "../../utils/logger";
import Routes from "../../components/Router/Routes"
import Timer from 'react-compound-timer';
import { LiveStreamStatusConstants } from "../../utils/constants";
import CustomDialog from "../../components/Modal/Modal"
import { useLiveStreamPlayer } from "../../hooks/useLiveStreamPlayer";

import { VideoPlayer } from '../../components/VideoPlayer';
import "../PlayerAndCorousel/views/Player/Player.css"
// import "video.js/dist/video-js.css";
const config = require("../../assets/config.json")




// window.videojs = videojs;
var starter = 0;
var curVideoTime = null;
function LiveStreamPlayer(props) {
    const intervalForStreaming = useRef(null);
    const isAuthenticated = localStorage.getItem("token");
    const { useLiveStreamPlayerState, useLiveStreamPlayerDispatch, liveStreamPlayerReducer } = useLiveStreamPlayer();
    const { recordedClasses, StreamingVideoLink, loading,
        // streamingVideo,
        isSubscriptionLoading, hasPlayerAccess,
        navigatedFromWhichScreen
    } = useLiveStreamPlayerState();

    const { clearLiveStreamRecordedData, liveStreamStarted, getUserSubscription,
        fetchStreamingLink, fetchRecordedClasses, saveDeeplinkPayload,
        setNavigatedFromWhichScreen, redirectForSSO, liveEventEnded,
        sendLiveStreamDurationToLocalytics, logOnDemandTracking } = useLiveStreamPlayerDispatch();

    const { initialState, useLiveStreamPlayerReducer, setReducerData } = liveStreamPlayerReducer
    const [liveStreamPlayerState, liveStreamPlayerDispatch] = useReducer(useLiveStreamPlayerReducer, initialState)
    const { FLLStreamingVideoLink, cardDetails, eventStatus, bindedPlayer, showLeaveModal, showImageLayoutOnly, videoInitialised, duration, eventId, pageShared, videoEnded, showAwaitError, showPopUPforSSO, videoStarted, fromDeepLink, liveVideoEnded } = liveStreamPlayerState


    var player = null;
    const interval = useRef(null);
    const isFLLEvent = (config.connectSource && config.connectSource.toLowerCase() === "wexer") ? true : false
    const isStreamingLinkEmpty = !StreamingVideoLink
    const updateEventStatus = ()=>{
        // setEventStatus(isStreamingLinkEmpty ? LiveStreamStatusConstants.AWAITING : LiveStreamStatusConstants.STREAMING)
        const setEventStatus = isStreamingLinkEmpty ? LiveStreamStatusConstants.AWAITING : LiveStreamStatusConstants.STREAMING
        setReducerData(liveStreamPlayerDispatch,{eventStatus : setEventStatus})
    }
    useEffect(() => {
        return (() => {

            /**
             * Nikhil Gupta 28th Sept, 2020
             * CF-8997 
             * clearing the recoded class 
             * this is done to sent the same event to localytics 
             * if the user navigates from player to another Page
             */

            // if (!(player && player.currentTime()))
            //     dispatch(clearLiveStreamRecordedData())
            if (bindedPlayer) {
                onVideoEnded()
                bindedPlayer.remove();
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bindedPlayer]
    );

    useEffect(() => {
        return () => {
            if (!(player && player.currentTime())) {
                clearLiveStreamRecordedData()
                liveStreamStarted(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (isAuthenticated) {
            if(!isSubscriptionLoading)getUserSubscription()
            if (props.location.state) {
                setReducerData(liveStreamPlayerDispatch,{fromDeepLink : false , eventId : (props.location.state.cardDetails.id) })

                if (!isFLLEvent) {
                    fetchStreamingLink(props.location.state.cardDetails.id)
                    fetchRecordedClasses(props.location.state.cardDetails.id, props.location.state.cardDetails.nextOccurence)
                    // check in case of vimeo
                    setReducerData(liveStreamPlayerDispatch,{eventStatus : isStreamingLinkEmpty ? LiveStreamStatusConstants.UNAVAILABLE : (props.location.state.cardDetails.eventStatus)})
                } else {
                    fetchRecordedClasses(props.location.state.cardDetails.id, props.location.state.cardDetails.nextOccurence, props.location.state.cardDetails.videoId)
                    if (props.location.state.cardDetails.duration) {
                        if (
                            new Date().getTime() > new Date(props.location.state.cardDetails.activeTime).getTime() &&
                            new Date().getTime() < new Date(props.location.state.cardDetails.activeTime).getTime() +
                            props.location.state.cardDetails.duration * 60 * 1000) {
                            setReducerData(liveStreamPlayerDispatch,{eventStatus : (isStreamingLinkEmpty ? LiveStreamStatusConstants.AWAITING : LiveStreamStatusConstants.STREAMING)})

                        } else {
                            setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.UNAVAILABLE)})

                        }
                    }
                    if (props.location.state.cardDetails.durationInSec) {
                        checkEventEnded(props.location.state.cardDetails.durationInSec, props.location.state.cardDetails.nextOccurence)
                    }
                }
                setReducerData(liveStreamPlayerDispatch, { FLLStreamingVideoLink: (props.location.state.cardDetails.url), cardDetails: (props.location.state.cardDetails) })
            }
            else {
                const path = props.location.pathname;
                var pathItems = path.split("/");
                let eventId = ""
                if (pathItems.length > 2 && pathItems[1] === "live") {
                    eventId = pathItems[2]
                }
                else if (pathItems.length > 2 && pathItems[2] === "live") {
                    eventId = pathItems[3]
                }
                setReducerData(liveStreamPlayerDispatch,{eventId : eventId})
                if (!isFLLEvent) {
                    setReducerData(liveStreamPlayerDispatch,{pageShared : true})
                    fetchStreamingLink(pathItems[3])
                    //dispatch(FetchRecordedClasses(pathItems[2],props.location.state.cardDetails.nextOccurence))
                    fetchRecordedClasses(pathItems[3], "")
                }
                else {
                    fetchRecordedClasses(pathItems[3])
                }
            }
        } else {
            const path = props.location.pathname;
            let isDeepLink = props.location.state;
            if (!isDeepLink) {
                saveDeeplinkPayload(path)
            }
            if (navigatedFromWhichScreen === "SIGNIN") {
                props.history.goBack()
                setNavigatedFromWhichScreen("")
                return
            }
            else
                setNavigatedFromWhichScreen("")
            var callback = () => {
                setNavigatedFromWhichScreen("SIGNIN")
                props.history.push({ pathname: "/signin", state: path });
            }
            redirectForSSO(callback)
        }

        return () => {
            interval && clearInterval(interval.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const checkEventEnded = (durationInSec, nextOccurence) => {
        try {
            let videoDurationMins = Math.floor(durationInSec / 60);
            let videoDurationSecs = durationInSec;
            if (videoDurationSecs >= 60)
                videoDurationSecs = (durationInSec / 60).toString().split('.');
            let videoStreamingTime = new Date(nextOccurence);
            videoStreamingTime.setMinutes(videoStreamingTime.getMinutes() + videoDurationMins);
            if (videoDurationSecs.length > 0) {
                let seconds = parseInt(videoDurationSecs[1].slice(0, 2))
                videoStreamingTime.setSeconds(videoStreamingTime.getSeconds() + seconds);
            }
            else {
                let seconds = parseInt(videoDurationSecs)
                videoStreamingTime.setSeconds(videoStreamingTime.getSeconds() + seconds);
            }
            let currentTime = new Date()
            if (currentTime > videoStreamingTime) {
                setReducerData(liveStreamPlayerDispatch,{liveVideoEnded : true })
                return true
            }
            return false
        }
        catch (error) {
            return false
        }
    }

    useEffect(() => {
        if (!loading && !isSubscriptionLoading && liveVideoEnded) {
            liveEventEnded();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, isSubscriptionLoading, liveVideoEnded])

    useEffect(() => {

        if (recordedClasses) {
            if (recordedClasses.eventDetail.live.status !== LiveStreamStatusConstants.STREAMING) {
                if (!recordedClasses.eventDetail.schedule) {
                    // if (recordedClasses.eventDetail.live.scheduled_Start_Time < new Date()) {
                    liveEventEnded();
                    props.history.push({
                        pathname: Routes.connectLiveSchedule,
                        state: { clubClasses: props.clubClasses }
                    });
                    // }
                } else {
                    if (eventStatus === LiveStreamStatusConstants.STREAMING) {
                        if (new Date(cardDetails.nextOccurence) <= new Date(recordedClasses.eventDetail.next_Occurrence_Time)) {
                            setReducerData(liveStreamPlayerDispatch, {
                                cardDetails: ({ ...cardDetails, nextOccurence: recordedClasses.eventDetail.next_Occurrence_Time }),
                                eventStatus: (LiveStreamStatusConstants.UNAVAILABLE)
                            })
                        }
                    } else if (fromDeepLink) {
                        setReducerData(liveStreamPlayerDispatch, {
                            cardDetails: ({
                                activeTime: recordedClasses.eventDetail.schedule.next_Occurence_Time + ".000Z",
                                description: recordedClasses.eventDetail.description,
                                eventStatus: recordedClasses.eventDetail.live.status,
                                id: recordedClasses.event_id,
                                nextOccurence: recordedClasses.eventDetail.schedule.next_Occurence_Time + ".000Z",
                                thumbnail: recordedClasses.eventDetail.sizes[0].link,
                                title: recordedClasses.eventDetail.name,
                                trailerLinkWeb: recordedClasses.liveStreamingLink,
                            }),
                            FLLStreamingVideoLink: (recordedClasses.liveStreamingLink)
                        })
                        if (!checkEventEnded(recordedClasses.eventData.duration, recordedClasses.eventDetail.schedule.next_Occurence_Time + ".000Z")) {
                            const sDate = new Date(recordedClasses.eventDetail.schedule.next_Occurence_Time + ".000Z");
                            if (
                                new Date().getTime() > new Date(sDate).getTime() &&
                                new Date().getTime() < new Date(sDate).getTime() +
                                recordedClasses.eventData.duration * 60 * 1000) {
                                setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.STREAMING)})

                            }
                        }
                    }

                }
            }
            if (pageShared) {
                setReducerData(liveStreamPlayerDispatch, {
                    cardDetails: ({
                        activeTime: recordedClasses.eventDetail.live.active_Time,
                        description: recordedClasses.eventDetail.description,
                        eventStatus: recordedClasses.eventDetail.live.status,
                        id: eventId,
                        isClubConnect: true,
                        nextOccurence: recordedClasses.eventDetail.next_Occurrence_Time,
                        thumbnail: recordedClasses.eventDetail.sizes[0].link,
                        title: recordedClasses.eventDetail.name,
                        trailerLinkWeb: recordedClasses.trailerLinkWeb,
                    }),
                    eventStatus: (recordedClasses.eventDetail.live.status)
                })
            }
        }
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordedClasses])

    useEffect(() => {
        if (recordedClasses && videoStarted && isFLLEvent) {
            liveStreamStarted(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordedClasses,videoStarted])

    useEffect(() => {
        if (StreamingVideoLink) {
            if (StreamingVideoLink.includes("https")) {
                interval && clearInterval(interval.current)
                if (!isFLLEvent)  setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.STREAMING)  }); //setEventStatus(LiveStreamStatusConstants.STREAMING);  

            } else {
                if (interval.current) {
                    setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.AWAITING)})

                } else {
                    setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.UNAVAILABLE)})

                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [StreamingVideoLink])

    useEffect(() => {
        if (!isSubscriptionLoading&&isSubscriptionLoading!==null) {
            if (hasPlayerAccess === false) {
                if (config.showUpgradeSubscriptionPopUp) {
                    setReducerData(liveStreamPlayerDispatch,{showPopUPforSSO : true ,eventStatus : (LiveStreamStatusConstants.UNAVAILABLE)})

                } else {
                    if (isAuthenticated)
                        props.history.push({ pathname: "/subscribe" });
                }
            } else {
                setReducerData(liveStreamPlayerDispatch,{showPopUPforSSO : false })
            }
        }
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSubscriptionLoading])

    function checkForStreamRecursively(nextOccurence) {
        if (nextOccurence) {
            var startTime = new Date().getTime();
            setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.AWAITING)})

            interval.current = setInterval(() => {
                if (new Date().getTime() - startTime > 60 * 10 * 1000) {
                    clearInterval(interval.current);
                    // setEventStatus(LiveStreamStatusConstants.UNAVAILABLE)
                    setReducerData(liveStreamPlayerDispatch, { showAwaitError : true})
                    return;
                }
                fetchStreamingLink(eventId)
            }, 5000)
        }
    }

    /* function onDurationChanged(time) {
        logger("Duration Event fired")
        logger(time);
        if (time == 0) {
            logger("Duration setting to 1")
            setReducerData(liveStreamPlayerDispatch,{duration : 1})

        }
        else {
            setReducerData(liveStreamPlayerDispatch,{duration : time})

            if (!videoEnded)
                onVideoEnded()
        }
    } */

    function onVideoEnded(isVideoEnd = false) {
        const userId = localStorage.getItem("userId");
        clearInterval(curVideoTime);
        curVideoTime = null;
        if (starter > 0) logOnDemandTracking(cardDetails, userId, starter, cardDetails?.isClubConnect ?? false);
        if ((starter > 60 || isVideoEnd) && recordedClasses?.type !== 2){
          //  postWorkoutResult(cardDetails,9,starter)
        }
        starter = 0;
        if(recordedClasses?.type === 2 && liveVideoEnded === false){
            setReducerData(liveStreamPlayerDispatch,{liveVideoEnded : true})
        }
        if(videoEnded === false) setReducerData(liveStreamPlayerDispatch,{videoEnded : true})
        if(showImageLayoutOnly === false) setReducerData(liveStreamPlayerDispatch,{showImageLayoutOnly : true})
    }
    const getSeekingTime = ()=>{
        if (isFLLEvent && eventStatus === "streaming") {
            if(fromDeepLink){
                if (recordedClasses.eventDetail.schedule.next_Occurence_Time) {
                    return new Date().getTime() - new Date(recordedClasses.eventDetail.schedule.next_Occurence_Time+ ".000Z").getTime()
                }
                else return false
            }
            else{
                if (props.location.state.cardDetails.activeTime) {
                    return new Date().getTime() - new Date(props.location.state.cardDetails.activeTime).getTime()
                }
                else return false
            }
        }
        else return false
    }
    function startVideo(video,jPlayer) {
        player=jPlayer;
        if (video != null && hasPlayerAccess && player!==null) {
                player.once("play", () => {
                    if (isFLLEvent)setReducerData(liveStreamPlayerDispatch,{videoStarted : true})
                        setReducerData(liveStreamPlayerDispatch,{bindedPlayer : player})
                    if (videoInitialised === false) {
                        setReducerData(liveStreamPlayerDispatch,{videoInitialised : true})
                        curVideoTime = setInterval(()=>starter++, 1000);
                        // setTimeout(() => {
                        //     const {dvrLive,...rest} = player.getConfig();
                        //     console.log(dvrLive,rest)
                        //     if(dvrLive !== true){
                        //         player.pause();
                        //         videoCompleteHandelMsg(player)
                        //         // onVideoEnded(true);
                        //     }
                        // }, 2000);
                        
                    }
                    const seekTime = getSeekingTime();
                    player.__proto__.wexer = {updateTime : true};
                    if(!isTrueLive() && seekTime && player.wexer)
                    {
                        //player.__proto__.wexer = {updateTime : true};
                        player.seek(seekTime / 1000);
                    }
                });
                player.once("remove", e => {
                    setReducerData(liveStreamPlayerDispatch,{showImageLayoutOnly : true})
                    sendLiveStreamDurationToLocalytics(player.getCurrentTime(),recordedClasses)
                })
                player.on("error", (e)=> {
                    if(e?.code === 230001 && navigator.onLine){
                        videoCompleteHandelMsg(player);
                        handelErrorMsg(player)
                    }
                })
                player.on("complete", e => {
                    console.log(e,player.getConfig(),"complete");
                    // e.stopImmediatePropagation()
                        logger('video is ended!');
                        videoCompleteHandelMsg(player);
                        // setImageLayOutStatus(true)
                })
        }
    }
    const handelErrorMsg = (jWplayer = bindedPlayer)=>{
        try {
            const videoErrEle = jWplayer.getContainer().querySelectorAll(".jw-error-msg");
            if(videoErrEle){
                videoErrEle[0].remove()
            }
        } catch (error) {
            
        }
        
    }
    const videoCompleteHandelMsg = (jWplayer = bindedPlayer)=>{
        if (document.fullscreenElement !== undefined && document.fullscreenElement !== null) {
            jWplayer.setAllowFullscreen(false);
        }
        setReducerData(liveStreamPlayerDispatch,{duration : jWplayer.getCurrentTime() || starter})
        if (!videoEnded) onVideoEnded(true)
    }
    const closehandlerCallback = () => {
        //Rajneesh raghav, Handling Close button
        if (eventStatus === LiveStreamStatusConstants.STREAMING) {
            logger(bindedPlayer);
            if (bindedPlayer) {
                bindedPlayer.dispose()
                // setPlayer(null);
                //setVideoInitialisation(null)
            }
        }
    };
    const closehandler = () => {
        if (eventStatus === LiveStreamStatusConstants.STREAMING) {
            if (showLeaveModal === true) {
                setReducerData(liveStreamPlayerDispatch,{showLeaveModal : false})

            } else {
                setReducerData(liveStreamPlayerDispatch,{showLeaveModal : true})

            }
        }
        else {
            if (fromDeepLink)
                props.history.push({ pathname: Routes.homePage });
            else
                props.history.goBack();
        }
    };
    const isTimeStart = ()=>{
        return isSLClassStarted(recordedClasses?.eventDetail?.schedule?.next_Occurence_Time+ ".000Z")
    }
    const isCountingShow = ()=>{
        const sDate = new Date(recordedClasses?.eventDetail?.schedule?.next_Occurence_Time+ ".000Z");
        const cDate = new Date();
        const diff = sDate - cDate;
        const dayLengthInMS = 24 * 60 * 60 * 1000;
        return diff < dayLengthInMS&&diff>0
    }
    const fetchRecords = (showLoading)=>{
        try{
            fetchRecordedClasses(props.location.state.cardDetails.id, props.location.state.cardDetails.nextOccurence,props.location.state.cardDetails.videoId,showLoading)
        }
        catch(e){
            fetchRecordedClasses(getEventId(),undefined,undefined,showLoading);
        }
    }
    const getEventId = ()=>{
        var path = props.location.pathname;
        var pathItems = path.split("/");
        if(pathItems.length>2&&pathItems[1]==="live"){
            return pathItems[2]
        }
        else if(pathItems.length>2&&pathItems[2]==="live"){
            return pathItems[3]
        }
    }
    const getRecordsRecursivly = useCallback(() => {
        intervalForStreaming.current = setInterval(() => fetchRecords(false), 5000);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
    ,[])
    useEffect(() => {
        if(!loading && !isEmpty(recordedClasses)){
            if(isStreamingLinkEmpty){
                // user checks fromDeepLink
                if( !isCountingShow() && fromDeepLink && eventStatus === null){
                    updateEventStatus();
                }
                if(props?.location?.state?.cardDetails?.eventStatus === "streaming"){
                    setTimeout(()=>{
                        if(!isCountingShow() && eventStatus === null&& liveVideoEnded === false){
                            setReducerData(liveStreamPlayerDispatch,{liveVideoEnded : true })
                            }
                    },2000);
                }
                if( eventStatus === LiveStreamStatusConstants.AWAITING){
                    getRecordsRecursivly();
                }
            }
            else{
                if(eventStatus !== LiveStreamStatusConstants.STREAMING){
                    // check if event is live or recorded
                    if(recordedClasses?.type === 2){
                        setReducerData(liveStreamPlayerDispatch,{FLLStreamingVideoLink : recordedClasses.liveStreamingLink, eventStatus: LiveStreamStatusConstants.STREAMING })
                    }
                    
                    // check if event is recorded and recorded time is less than current time
                    else if(isTimeStart()){
                        if(isFLLEvent && FLLStreamingVideoLink === null){
                            setReducerData(liveStreamPlayerDispatch,{FLLStreamingVideoLink : recordedClasses.liveStreamingLink})
                        }
                        setReducerData(liveStreamPlayerDispatch,{eventStatus: LiveStreamStatusConstants.STREAMING })
                    }
                }
            }
        }
        return()=>{
            intervalForStreaming && clearInterval(intervalForStreaming.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventStatus,isStreamingLinkEmpty,recordedClasses,loading,isCountingShow,fromDeepLink,LiveStreamStatusConstants.AWAITING])
    const classStartsIn = (startTime) => {
        const sDate = new Date(startTime);
        const cDate = new Date();
        const diff = sDate - cDate;
        const dayLengthInMS = 24 * 60 * 60 * 1000
        if (diff < dayLengthInMS && diff > 0) {
            return (
                <Timer checkpoints={[
                    {
                        time: 0,
                        callback: () => {
                            if (isFLLEvent) {
                                setReducerData(liveStreamPlayerDispatch,{eventStatus : (LiveStreamStatusConstants.AWAITING)})

                            } else {
                                checkForStreamRecursively(cardDetails.nextOccurence)
                            }
                        }
                    },
                ]}
                    formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`} initialTime={diff || 0} direction="backward">
                    <Timer.Hours />{':'}<Timer.Minutes />{':'}<Timer.Seconds />
                </Timer>)
        }
    }

    const handleMemberShipDialog = () => {
        if (config.UpgradeRedirect != null) {
            window.open(config.UpgradeRedirect, '_blank')
            props.history.goBack();
        }
        else {
            setReducerData(liveStreamPlayerDispatch,{showPopUPforSSO : false })

        }
      }
    const isTrueLive=()=>recordedClasses?.type === 2;
    return (
        <Fragment>
            {loading || isSubscriptionLoading ? <Spinner /> : cardDetails && <div className="page-container">
                <CustomDialog
                    open={showPopUPforSSO}
                    title={Translate({ id: "Subscription.UpgradeMembership" })}
                    heading={Translate({ id: "Subscription.UpgradeMessage" })}
                >
                    <div className="text-center padding16">
                        <Button size="small" type="submit" color="secondary"
                            className="button btn-default" variant="contained"
                            onClick={handleMemberShipDialog}
                            style={{ marginTop: "60px" }}
                        >
                            <Typography variant="h5">
                                {Translate({ id: "Subscription.Ok" })}
                            </Typography>
                        </Button>
                    </div>
                </CustomDialog>
                <Grid container justify="flex-start" direction="row">
                    {/* <Grid item variant="contained" lg={12} md={12} sm={12} xs={12}> */}
                    <div className="livePlayer clear video-wrapper" id='video-wrapper'>
                        {eventStatus === LiveStreamStatusConstants.STREAMING ?
                            <Fragment>
                                <PureVideoWrapper isVideoInit={videoInitialised} eventStatus={eventStatus}>
                                    <div className='livePlayer ClassPlayer video-js'>
                                        <VideoPlayer
                                            startVideo={startVideo}
                                            hideControls={!isTrueLive()}
                                            isLive
                                            autostart
                                            file={isFLLEvent ? FLLStreamingVideoLink : StreamingVideoLink}
                                            image={cardDetails.thumbnail}
                                            eventId={eventId}
                                        />
                                    </div>
                                </PureVideoWrapper>
                                <div className="livePlayer-info2">
                                    <div className="container-info">
                                        <img
                                            alt="close"
                                            className="CloseButton livePlayerClose btn-default hidden-xs"
                                            src={require("../../assets/images/close.png")}
                                            onClick={closehandler}
                                        />
                                        <div className="btn-container" onClick={closehandler}>
                                            <img alt="close" src={require("../../assets/images/closeGreen.svg")} />
                                        </div>
                                        {/* <Typography variant="body1">
                                            <span className="live-label">{Translate({ id: "liveStream.Live" })}</span>
                                        </Typography> */}
                                    </div>
                                </div>
                            </Fragment>
                            :
                            <div className="livePlayer video-js noBorderRadiusButton" style={{ zIndex: 0 }}>
                                <img src={cardDetails.thumbnail} style={{ width: "100%", height: "100%" }} className="noBorderRadiusButton" alt='cardThumbnail'/>
                                <div className="livePlayer-info noBorderRadiusButton livePlayer-loader">
                                    <div className="container-info">
                                    {eventStatus !== LiveStreamStatusConstants.AWAITING &&
                                        <React.Fragment>
                                            <img
                                                className="CloseButton livePlayerClose btn-default hidden-xs"
                                                src={require("../../assets/images/close.png")}
                                                onClick={closehandler}
                                                alt='closeButton'
                                            />
                                            <div className="btn-container" onClick={closehandler}>
                                                <img src={require("../../assets/images/closeGreen.svg")} alt='closeButton' />
                                            </div>
                                        </React.Fragment>}
                                    <Typography variant="body1">
                                        <span className="live-label">{Translate({ id: "liveStream.Live" })}</span>

                                        {eventStatus !== LiveStreamStatusConstants.AWAITING &&
                                            eventStatus !== LiveStreamStatusConstants.STREAMING &&
                                            <span className="timeDayText">
                                                {getNextOccurenceDate(cardDetails.eventStatus, cardDetails.activeTime, cardDetails.nextOccurence)}
                                                {" "}{Translate({ id: "liveStream.at" })}{" "}
                                                {getTimetoStart(cardDetails.nextOccurence)}
                                            </span>
                                        }
                                    </Typography>
                                    {eventStatus === LiveStreamStatusConstants.AWAITING &&
                                        <React.Fragment>
                                            {!showAwaitError && <Spinner size={20} thickness={3} />}
                                            <div className="loader-caption">{showAwaitError ? Translate({ id: "liveStream.AwaitingStreamError" }) :
                                                Translate({ id: "liveStream.AwaitingStream" })}</div>
                                        </React.Fragment>}
                                    {eventStatus !== LiveStreamStatusConstants.AWAITING &&
                                        <p className="timer">
                                            {classStartsIn(cardDetails.nextOccurence)}
                                        </p>
                                    }
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            showLeaveModal &&
                            <Modal currentTime={duration}
                                classDetails={cardDetails}
                                history={props.history}
                                callback={closehandlerCallback}
                                class="liveStram-video-paused-infobox"
                                fromDeepLink={fromDeepLink}
                            />
                        }
                        {showImageLayoutOnly &&
                            <React.Fragment>
                                <ClassCompleted history={props.history} cardDetails={cardDetails} duration={duration} />
                            </React.Fragment>

                        }
                    </div>
                    <Grid item variant="contained" lg={12} md={12} sm={12} xs={12}>
                        <div className='new-video-metadata'>
                            <div className='vido-metadata-row'>

                                <div className="clear m-t-15  m-t-xs-15 align-left">
                                    <Typography variant="h1">
                                        {cardDetails.title}
                                    </Typography>
                                    <Typography variant="h6" className="text-gray" style={{ whiteSpace: "pre-wrap" }}>
                                        {cardDetails.description}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    {(recordedClasses && recordedClasses.eventData.length) ? <Fragment>
                        <Grid item variant="contained" lg={12} md={12} sm={12} xs={12}>
                            <div className="clear m-t-40  m-t-xs-15 align-left m-b-5 m-b-xs-10">
                                <Typography variant="body1">
                                    {cardDetails.title}{": "}
                                    {Translate({ id: "liveStream.RecordedClasses" })}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid container justify="flex-start" spacing={4} className="">
                            {!recordedClasses.eventData ?
                                <Grid item>
                                    <Typography className="text-gray align-left m-t-xs-15" variant="h6" >
                                        {Translate({ id: "liveStream.NoRecordedResult" })}
                                    </Typography>
                                </Grid> :
                                recordedClasses.eventData && Array.isArray(recordedClasses.eventData) ? recordedClasses.eventData.filter(
                                    (item) => item.videoID && item.streamingLink).map(
                                        (eventData) =>
                                            <Grid item lg={4} md={6} sm={12} xs={12} key={eventData.videoID}>
                                                <ClubCardNew clubData={eventData} liveStream={true} eventId={eventId}></ClubCardNew>
                                            </Grid>
                                    ) :
                                    <Grid item lg={4} md={6} sm={12} xs={12} key={recordedClasses.eventData.videoID}>
                                        <ClubCardNew clubData={recordedClasses.eventData} liveStream={true} eventId={recordedClasses.eventId}></ClubCardNew>
                                    </Grid>
                            }

                        </Grid>
                    </Fragment> : null}
                </Grid>
            </div>}
        </Fragment>
    )
}

export default (withRouter(LiveStreamPlayer));

